import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { A11y, Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import user from "../../Assets/Images/photo.jpg";

const Testimonials = () => {
    return (
        <>
            <div className="container py-5">
                <div className="row">
                    <div className="col-12">
                        <h2 className='text-center pb-5 fw-bold '>
                            Testimonial
                        </h2>
                    </div>
                    <div className="col-lg-12">
                        <Swiper
                            modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                            spaceBetween={50}
                            slidesPerView={3}
                            // navigation
                            pagination={{ clickable: true }}
                            autoplay={{ delay: 3000, disableOnInteraction: false }}
                            // scrollbar={{ draggable: true }}
                            onSwiper={(swiper) => console.log(swiper)}
                            onSlideChange={() => console.log('slide change')}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                    spaceBetween: 20,
                                },
                                576: {
                                    slidesPerView: 1,
                                    spaceBetween: 20,
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 30,
                                },
                                992: {
                                    slidesPerView: 3,
                                    spaceBetween: 50,
                                },
                            }}
                        >
                            <SwiperSlide>
                                <div className="bg-light p-5 w-100 rounded-1">
                                    <div className="row justify-content-center">
                                        <div className=" text-center">
                                            <p className=''>Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam officia laudantium est aut magni quam maiores placeat animi repellendus provident, ratione repellat a odio error in ab impedit debitis repudiandae?</p>

                                            <div className="row align-items-center justify-content-center">
                                                <div className="col-auto">
                                                    <img src={user} width={64} height={64} className='rounded-circle' alt="" />
                                                </div>

                                                <div className="col-auto">
                                                    <h5 className="fw-bold mb-0">
                                                        Talha Haq
                                                    </h5>
                                                    <p className='mb-0' style={{ fontSize: "12px" }}>Project manager </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="bg-light p-5 w-100 rounded-1">
                                    <div className="row justify-content-center">
                                        <div className=" text-center">
                                            <p className=''>Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam officia laudantium est aut magni quam maiores placeat animi repellendus provident, ratione repellat a odio error in ab impedit debitis repudiandae?</p>

                                            <div className="row align-items-center justify-content-center">
                                                <div className="col-auto">
                                                    <img src={user} width={64} height={64} className='rounded-circle' alt="" />
                                                </div>

                                                <div className="col-auto">
                                                    <h5 className="fw-bold mb-0">
                                                        Talha Haq
                                                    </h5>
                                                    <p className='mb-0' style={{ fontSize: "12px" }}>Project manager </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="bg-light p-5 w-100 rounded-1">
                                    <div className="row justify-content-center">
                                        <div className=" text-center">
                                            <p className=''>Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam officia laudantium est aut magni quam maiores placeat animi repellendus provident, ratione repellat a odio error in ab impedit debitis repudiandae?</p>

                                            <div className="row align-items-center justify-content-center">
                                                <div className="col-auto">
                                                    <img src={user} width={64} height={64} className='rounded-circle' alt="" />
                                                </div>

                                                <div className="col-auto">
                                                    <h5 className="fw-bold mb-0">
                                                        Talha Haq
                                                    </h5>
                                                    <p className='mb-0' style={{ fontSize: "12px" }}>Project manager </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="bg-light p-5 w-100 rounded-1">
                                    <div className="row justify-content-center">
                                        <div className=" text-center">
                                            <p className=''>Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam officia laudantium est aut magni quam maiores placeat animi repellendus provident, ratione repellat a odio error in ab impedit debitis repudiandae?</p>

                                            <div className="row align-items-center justify-content-center">
                                                <div className="col-auto">
                                                    <img src={user} width={64} height={64} className='rounded-circle' alt="" />
                                                </div>

                                                <div className="col-auto">
                                                    <h5 className="fw-bold mb-0">
                                                        Talha Haq
                                                    </h5>
                                                    <p className='mb-0' style={{ fontSize: "12px" }}>Project manager </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="bg-light p-5 w-100 rounded-1">
                                    <div className="row justify-content-center">
                                        <div className=" text-center">
                                            <p className=''>Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam officia laudantium est aut magni quam maiores placeat animi repellendus provident, ratione repellat a odio error in ab impedit debitis repudiandae?</p>

                                            <div className="row align-items-center justify-content-center">
                                                <div className="col-auto">
                                                    <img src={user} width={64} height={64} className='rounded-circle' alt="" />
                                                </div>

                                                <div className="col-auto">
                                                    <h5 className="fw-bold mb-0">
                                                        Talha Haq
                                                    </h5>
                                                    <p className='mb-0' style={{ fontSize: "12px" }}>Project manager </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>

                </div>
            </div>

        </>
    )
}

export default Testimonials